/* ==========================================================================
   Subscription wording, per page

   The subscription box is the Seal app's widget. Its two row titles come from
   the app ("One-time purchase", the plan group's name) and the lines under the
   chosen plan come from the gallery scripts. The brief gives the Biscotti and
   Cookie pages a Gift Box wording and the two Jar pages a Jar wording, so every
   line is a field on the product template (Giorgio product section →
   Subscription wording) and this file puts them in place.

   Only words. The prices in the box are Seal's own and are never touched here:
   what a subscriber is charged is decided in the app, and the page must show
   exactly that.

   [packaging] in the one-time line is replaced by the packaging chosen on the
   page ("Gift Box", "Dozen", "Cookie Jar"), so the Biscotti page can say
   "Gift Box Only" when a Gift Box is chosen without saying it over a Dozen.

   Every write is guarded: the widget is watched for re-renders, and a write
   that changes nothing would wake that watcher again.
   ========================================================================== */
(function () {
  'use strict';

  var COPY = window.ggSubCopy || {};
  if (!COPY.once && !COPY.plan && !COPY.note) return;

  var ROOT = '.sealsubs-target-element';

  function packaging() {
    var card = document.querySelector('.pkg-card.selected');
    var value = card ? card.getAttribute('data-value') : '';
    if (!value) {
      var sel = document.querySelector('.product-form-variant-2 input:checked');
      value = sel ? sel.value : '';
    }
    return String(value || '').replace(/^the\s+/i, '').trim();
  }

  function setText(el, text) {
    if (el && text && el.textContent !== text) el.textContent = text;
  }

  function apply() {
    var root = document.querySelector(ROOT);
    if (!root) return;

    var rows = root.querySelectorAll('.sls-option-container');
    Array.prototype.forEach.call(rows, function (row) {
      var input = row.querySelector('input.sls-option');
      var label = row.querySelector('label.sls-selling-plan-group-name');
      if (!input || !label) return;
      if (input.value === 'one_time') {
        if (COPY.once) {
          var pkg = packaging();
          var once = COPY.once.indexOf('[packaging]') === -1
            ? COPY.once
            : (pkg ? COPY.once.replace('[packaging]', pkg) : COPY.once.replace(/\s*[·\-–—]\s*\[packaging\]\s*\w*/i, ''));
          setText(label, once);
        }
      } else if (COPY.plan) {
        setText(label, COPY.plan);
      }
    });

    // The italic line under the description, as on the Jar mock.
    if (COPY.note) {
      var body = root.querySelector('#pkgSubBody');
      if (body) {
        var note = root.querySelector('#pkgSubNote');
        if (!note) {
          note = document.createElement('div');
          note.id = 'pkgSubNote';
          body.parentNode.insertBefore(note, body.nextSibling);
        }
        setText(note, COPY.note);
      }
    }
  }

  function boot() {
    var root = document.querySelector(ROOT);
    if (!root) return false;
    apply();
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; apply(); }, 0);
    }).observe(root, { childList: true, subtree: true, characterData: true });
    // The packaging is chosen outside the widget.
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.pkg-card')) setTimeout(apply, 0);
    });
    return true;
  }

  if (!boot()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (boot() || ++tries > 60) clearInterval(timer);
    }, 250);
  }
})();
